import { render, staticRenderFns } from "./PartsStatusTable.vue?vue&type=template&id=832ef77a&"
import script from "./PartsStatusTable.vue?vue&type=script&lang=ts&"
export * from "./PartsStatusTable.vue?vue&type=script&lang=ts&"
import style0 from "./PartsStatusTable.vue?vue&type=style&index=0&id=832ef77a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
